// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__rb7gr","errors":"Errors_errors__1R2T2"};